import { createApp } from '@app/adapters/create-app'

import TemplateActionsDropdown from '../components/template-actions-dropdown.vue'

export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const container = doc.querySelector(
      '[data-behaviour="pulse-template-actions-dropdown"]'
    ) as HTMLElement

    if (container) {
      createApp(TemplateActionsDropdown, container.dataset).mount(container)
    }
  })
}
